import _ from 'lodash';
import {DICTIONARY} from '../../dictionary';
import {GeneralService} from '../../services/generalService';
import {RouteService} from '../../services/routeService';
import {Component, NgZone, OnDestroy, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {NotificationService} from "../../services/notificationService";
import util from "util";


@Component({
	selector: 'knowledge-component',
	templateUrl: './knowledge.component.html',
})
export class KnowledgeComponent implements OnInit, OnDestroy{
    constructor(private rs:RouteService,
				public router:Router,
				public activatedRoute:ActivatedRoute,
				public gs:GeneralService,
				public ns:NotificationService,
				private ngZone:NgZone) {
    }

    dic = DICTIONARY;
    searchQuery = '';
    searchResultsList = [];
    showResultModal = false;
    highlightSearchResults = false;
    highlightSearchText = '';
    infoLibraries;
    selectedLibrary;
    showScrollToTop;
    searchInProcess;
    sensitivityEngineList;
	parentScrollableElement;
    // set to info page by default (and not to main) since the access to knowledge main page is only through the info pages currently :
    pageModule = this.dic.CONSTANTS.supportPageModules.info;
	_=_;
	showWhatsNewFilterMenu;
	userInfo;

	trustifiModules = {
		'Inbound Shield': { enabled: false, color: '#197d90' },
		'Outbound Shield': { enabled: false, color: '#b12424' },
		'Archive': { enabled: false, color: '#8E44AD' },
		'Threat Simulation': { enabled: false, color: '#F5A623' },
		'Domain Protection': { enabled: false, color: '#10b603' },
		'Partners': { enabled: false, color: '#3b00ff' },
		'Account Takeover Protection': { enabled: false, color: '#c2188c' },
		'Account & Support': { enabled: false, color: '#525252' },
		'Collaboration Shield': { enabled: false, color: '#2E86AB' }
	};


	whatsNewData = [];
	faqLib = [];

    kBase = [
        {
            title: "Sensitivity Engine",
            infoBlocks: [
                {
                    title: "Purpose and usage",
                    info: ["Sensitive data is defined as data in an email containing personal, business or confidential information that could cause a security leak; this information is essential to keep classified within the organization/business. The sensitivity engine is best used by clients to make sure sensitive data is either being sent within the business safely or to manage sensitive data. According to the Sensitivity <strong>Score</strong> Mechanism of each email, rules can be set regarding authentication and other security requirements on the email. Using these capabilities can help organizations protect their data, their user’s privacy, as well as meet the different compliance's that exist today."]
                },
                {
                    subtitle: "Data Loss Prevention (DLP)",
                    info: ["Data loss prevention is used to make sure sensitive information is controlled within and outside a company. Without control, personal or business security would be at risk, and endless data could be stolen. The sensitivity engine, combined with the rule’s engine, works as DLP to control email security options on sent emails. Our sensitivity engine allows the admin to automatically and easily monitor end-user usage of sensitive documents. The admin of the company can set certain rules and policies to ensure that sensitive emails are sent with the correct security options enabled to prevent the risk of private data."]
                },
                {
                    title: "Compliance and Regulations",
                    info: ["We are compliant with regulations that target specific types of personal and business security to classify levels of sensitivity. Different types of private information are classified under different types of worldwide security protocols, and the sensitivity engine tags and scores sensitive information under the following regulations."]
                },
                {
                    subtitle: "General Data Protection Regulation (GDPR)",
                    info: ["GDPR aims to protect personal data. This personal data can be as non-sensitive as an email address or business phone number to highly sensitive information as a social security number. Sensitivity scores for GDPR-based information may vary based on the level of personal privacy."]
                },
                {
                    subtitle: "Family Educational Rights and Privacy Act (FERPA)",
                    info: ["FERPA is a federal law that affords parents the right to have access to their children’s education records, the right to seek to have the records amended, and the right to have some control over the disclosure of personally identifiable information from the education records."]
                },
                {
                    subtitle: "Health Insurance Portability and Accountability Act (HIPAA)",
                    info: ["HIPAA is the regulation regarding all health-related and medical information. This information can be classified as sensitive, as patient identification or historical data leaks could put a person’s privacy at risk."]
                },
                {
                    subtitle: "Payment Card Industry Data Security Standard (PCI DSS)",
                    info: ["PCI DSS refers to all information regarding finance and credit/debit cards. As this information involves personal and business bank accounts and financials, emails containing this type of information will be tagged as having a higher level of sensitivity. The sensitivity engine uses combinations of found phrases in correlation to the three listed compliance regulations to create a sensitivity score."]
                },
                {
                    subtitle: "California Consumer Privacy Act (CCPA)",
                    info: ["The CCPA is a law designed to protect the data privacy rights of citizens living in California, similar to GDPR, but aims to encompass all of the sensitive and personal information related to a consumer or household."]
                },
                {
                    subtitle: "Protection of Personal Information (POPI) Act",
                    info: ["POPI refers to South Africa’s Protection of Personal Information Act which seeks to regulate the Processing of Personal Information."]
                },
                {
                    subtitle: "General Data Protection Law (LGPD)",
                    info: ["Like GDPR and CCPA, LGPD is the Brazilian data protection law focused on Brazilian related sensitive information or documents."]
                },
                {
                    subtitle: "Personal Data (Privacy) Ordinance (PDPO)",
                    info: ["PDPO is one of Asia’s longest standing comprehensive data protection laws which protects the privacy of individuals in relation to personal data."]
                },
                {
                    subtitle: "Gramm–Leach–Bliley Act (GLBA)",
                    info: ["The Gramm-Leach-Bliley Act requires financial institutions – companies that offer consumers financial products or services like loans, financial or investment advice, or insurance – to explain their information-sharing practices to their customers and to safeguard sensitive data."]
                },
                {
                    title: "How the engine works",
                    info: ["The engine works by matching tagged words, sentence parts, numbers, complex patterns with those in our database as well as Machine Learning. We do not read or receive the information in the email; the system scans the contents of the email such as the subject, body, files, file names, file types, and extensions and assigns a Sensitivity Score, Category and Compliance-based on the patterns that were matched. Examples of patterns in the database include keywords and number formats that would be contained in a sensitive document. If the engine detects certain patterns that could be classified as a credit card category, the email will be tagged as sensitive, with the appropriate Sensitivity-Scores and relevant Compliance/s (GDPR, FERPA, HIPAA, PCI, CCPA, POPI, PDPO, LGPD and GLBA)."]
                },
                {
                    title: "Sensitivity categories",
                    info: ["Each pattern or detection function in a system is associated with a particular category of sensitivity such as “Employee Information”, “Bank Account Information”, “Credit Card”, and many more. Each category is associated with the relevant compliance/s (GDPR, FERPA, HIPAA, PCI, CCPA, POPI, PDPO, LGPD and GLBA)."]
                },
                {
                    title: "Sensitivity Score Mechanism",
                    info: ["Sensitivity data detection and classification is something that is very difficult, subjective, and every company/business/individual can define it differently. Therefore, we created the Sensitivity-Score-Mechanism, based on in-depth research and questioning from many clients from different fields.",
                        "The score values range from 0 (not sensitive) to 5 (highly sensitive), where Each value is derived from a combination of:\n" +
                        "  - Sensitivity severity - How severe the finding we suspect we found based on its Sensitivity Category\n" +
                        "  - Reliability level - How confident we are that what we found is true",
                        "Each of these parameters is calculated in a sophisticated method based on many studies and analysis of millions of documents of any type.",
                        "After the system determines the highest final Sensitivity Score (we can detect many sensitivity categories but only the one with the highest Sensitivity-Score is counted), it combines all the sensitivity data together: Sensitivity Score, Sensitivity Category and Compliance/s."]
                },


            ]
        }
    ];


	ngOnInit() {

		this.gs.getUserInfo(false, (userInfo) => {
			this.userInfo = userInfo;
		});

		this.getTrustifiKnowledge();

		this.parentScrollableElement = document.getElementById('main')
		this.parentScrollableElement.addEventListener('scroll', this.scrollToTopBtn);

        this.infoLibraries = {
            FAQ: {
                title: "Frequently Asked Questions",
                libraryObj: this.faqLib || []
            },
            knowledgeBase: {
                title: "Knowledge Base",
                libraryObj: this.kBase
            }
        }

        // There are 3 page modules in knowledge base: main | info | timeScale
        // main module used for the "welcome" page of the support section. info page is used in FAQ and Knowledge Base. timeScale is used in What's New page
		const pageModel = this.router.url.substring(1).split('/')[1];
		const urlQuery = this.activatedRoute.snapshot.paramMap;
		const anchorId = window.history.state.anchorId || urlQuery.get('anchorId');

		switch (pageModel) {
			case this.dic.CONSTANTS.supportPages.knowledgeBase:
				this.goToInfoPage(this.infoLibraries.knowledgeBase, anchorId);
				break;

			case this.dic.CONSTANTS.supportPages.faq:
				this.goToInfoPage(this.infoLibraries.FAQ, anchorId);
				break;

			case this.dic.CONSTANTS.supportPages.whatsNew:
				this.pageModule = this.dic.CONSTANTS.supportPageModules.timeScale;
				break;

			default:
				this.pageModule = this.dic.CONSTANTS.supportPageModules.main;
		}
    }

	getTrustifiKnowledge = () => {
		if (this.whatsNewData?.length) {
			return;
		}

		this.rs.getTrustifiKnowledge().then((response) => {
			this.whatsNewData = response.whatsNew;
			this.faqLib = response.faq;
			this.infoLibraries.FAQ.libraryObj = this.faqLib;

			this.sensitivityEngineList = response.detectors;
			this.parseSensitivityEngineList();
		});
	}

	ngOnDestroy() {
		this.parentScrollableElement.removeEventListener('scroll', this.scrollToTopBtn);
	}

	goToInfoPage(infoLibrary, anchorText) {
        // reset search text highlight on navigation:
        this.highlightSearchResults = false;
        this.highlightSearchText = '';
        //

        this.selectedLibrary = infoLibrary;
        this.pageModule = this.dic.CONSTANTS.supportPageModules.info;

        if (anchorText) {
            setTimeout(()=>{
                this.scrollToAnchor(anchorText.replace(/ /g, "_"));
            },350);
        }
        else {
            this.scrollToTop();
        }
    };

    parseSensitivityEngineList() {
		let table = '<div class="w-100 knowledge-custom-table flex-column border"><div class="flex-row align-items-center bg-opacity-10 bg-primary py-2 f-1-0 knowledge-ct-first-row">' +
		'<div class="f-1-0 px-2 knowledge-fBasis-30"><b>Name</b></div>' +
		'<div class="f-1-0 px-2 knowledge-fBasis-5"><b>Type</b></div>' +
		'<div class="f-1-0 px-2 knowledge-fBasis-5"><b>Min score</b></div>' +
		'<div class="f-1-0 px-2 knowledge-fBasis-5"><b>Max score</b></div>' +
		'<div class="f-1-0 px-2 knowledge-fBasis-30"><b>Compliances/Regulations</b></div>' +
		'</div>';
		for (let i = 0; i < this.sensitivityEngineList.length; i++) {
			if (i % 2 !== 0) { table += '<div class="flex-row py-2 f-1-0 border align-items-center bg-primary bg-opacity-10 border-bottom-0">'; } else {
				table += '<div class="flex-row py-2 f-1-0 border align-items-center border-bottom-0" style="border-bottom: unset!important;">'
			}
			table += `<div class="f-1-0 px-2 knowledge-fBasis-30">${this.sensitivityEngineList[i].name}</div>`;
			table += `<div class="f-1-0 px-2 knowledge-fBasis-5">${this.sensitivityEngineList[i].type}</div>`;
			table += `<div class="f-1-0 px-2 knowledge-fBasis-5">${this.sensitivityEngineList[i].min_score}</div>`;
			table += `<div class="f-1-0 px-2 knowledge-fBasis-5">${this.sensitivityEngineList[i].max_score}</div>`;
			table += `<div class="f-1-0 px-2 knowledge-fBasis-30">${this.sensitivityEngineList[i].compliance.join(', ') || 'N/A'}</div></div>`;
			if (this.sensitivityEngineList[i].sub_detector) {
				if (i % 2 !== 0) { table += `<div class="flex-column bg-primary bg-opacity-10 knowledge-ct-subDetector">`; } else {
					table += `<div class="flex-column knowledge-ct-subDetector">`;
				}
				for (let j = 0; j < this.sensitivityEngineList[i].sub_detector.length; j++) {
					table += `<div class="flex-row w-100 py-1 align-items-center">`;
					table += `<div class="flex-column ps-4 f-1-0 knowledge-fBasis-30">`;
					// table += `<b>Name:</b>`;
					table += `<span>${this.sensitivityEngineList[i].sub_detector[j].name}</span>`;
					table += `</div>`;
					table += `<div class="flex-column px-2 f-1-0 knowledge-fBasis-5">`;
					// table += `<b>Type:</b>`;
					table += `<span>${this.sensitivityEngineList[i].sub_detector[j].type}</span>`;
					table += `</div>`;
					table += `<div class="flex-column px-2 f-1-0 knowledge-fBasis-5">`;
					// table += `<b>Min score:</b>`;
					table += `<span>${this.sensitivityEngineList[i].sub_detector[j].min_score}</span>`;
					table += `</div>`;
					table += `<div class="flex-column px-2 f-1-0 knowledge-fBasis-5">`;
					// table += `<b>Max score:</b>`;
					table += `<span>${this.sensitivityEngineList[i].sub_detector[j].max_score}</span>`;
					table += `</div>`;
					table += `<div class="flex-column px-2 f-1-0 knowledge-fBasis-30">`;
					// table += `<b>Compliances:</b>`;
					table += `<span>${this.sensitivityEngineList[i].sub_detector[j].compliance.join(', ') || 'N/A'}</span>`;
					table += `</div>`;
					table += `</div>`;

				}
				table += `</div>`;

			}
			table += `<tr>`;
		}

		table += '</div>';

		this.kBase[0].infoBlocks.push(
			{
			title: "Examples",
			// actions: [{name: "Export to CSV"}],
			info: ["Working with compliance regulations and levels of privacy, the table below summarizes different types of sensitive information and their respective score ranges, types, and compliance's and/or regulations",
				table,
				"We are always researching, improving and upgrading the sensitivity-engine, so there may be changes in the table from time to time. We recommend staying up to date from our web-portal."]
			}
		);

		// rescroll to anchor since the pushed table changed the page's scroll position
		if (window.history.state.anchorId) {
			this.scrollToAnchor(window.history.state.anchorId);
		}
    }

    scrollToAnchor(id) {
        // 'id' can be sent from within controller (as normal string) or by the URL address from outside the src (as encoded URL string)
        // (question mark in the end of the URL is automatically removed by browser, but can still be in id so we check it too)
        const targetElement = document.getElementById(id) || document.getElementById(id + '?') || document.getElementById(decodeURIComponent(id));
        if (!targetElement) {
            return;
        }

        // timeout to let time for the search query upper section to minimize before scrolling
        setTimeout(() => {
            this.parentScrollableElement.scroll({
                top: targetElement.offsetTop - this.parentScrollableElement.offsetTop,
                left: 0,
                behavior: 'smooth'
            });
        }, this.pageModule === this.dic.CONSTANTS.supportPageModules.main ? 150 : 0);

    }

    scrollToTopBtn = () => {
		this.ngZone.run(() => {
			this.showScrollToTop = this.parentScrollableElement.scrollTop > 200 && this.pageModule !== this.dic.CONSTANTS.supportPageModules.main
		})
    }

    scrollToTop() {
		this.parentScrollableElement.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }

    searchInLibraries(searchTerm) {

        // reset highlight when search query is changed
        this.highlightSearchResults = false;
        this.highlightSearchText = '';
        //

        if (!searchTerm || searchTerm.length < 2) {
            this.searchResultsList = [];
            this.searchInProcess = false;
            this.showResultModal = false;
            return;
        }

        this.showResultModal = true;
        this.searchInProcess = true;

        searchTerm = searchTerm.toLowerCase();

        // single resultObj format: {SLO: source_library_object , SCT: second_closest_title , CT: closest_title , EC: end_content}
        let results = [];

        for (const LibraryKey in this.infoLibraries) {
            const LibraryContent = this.infoLibraries[LibraryKey];
            LibraryContent.libraryObj.forEach(subLibrary => {
                // search in sub-library title:
                if (subLibrary.title.toLowerCase().includes(searchTerm)) {
                    results.push({
                        sourceLibrary : LibraryContent , // source library object
                        secondClosestTitle: subLibrary.title , // second_closest_title
                    })
                }
                // search in sub-library infoBlocks:
                subLibrary.infoBlocks.forEach(infoBlock => {
                    if (JSON.stringify(infoBlock).toLowerCase().includes(searchTerm)) {
                        results.push({
                            sourceLibrary : LibraryContent , // source library object
                            secondClosestTitle: subLibrary.title , // second_closest_title
                            closestTitle: Object.values(infoBlock)[0] , // closest_title
                            endContent: Object.values(infoBlock)[1] // end_content
                        })
                    }
                })
            })
        }

        // search in "what's new" library (forEach twice BUT this library is not big at all and should never be)
        this.whatsNewData.forEach(newFeaturesBundle => {
            newFeaturesBundle.features.forEach(newFeature => {
                if (newFeature.text.toLowerCase().includes(searchTerm)) {
                    results.push({
                        sourceLibrary : "What's New" , // source library name
                        closestTitle: (new Date(newFeaturesBundle.date)).toLocaleDateString('en-US', { day: "2-digit" , month: '2-digit', year: 'numeric'})  , // closest_title
                        endContent: [newFeature.text] // end_content
                    })
                }
            })
        })

        this.searchInProcess = false;
        this.searchResultsList = results;
    }

    clickOnSearchResult(result) {
        this.showResultModal = false;

        if (result.sourceLibrary === this.infoLibraries.knowledgeBase) {
            this.goToInfoPage(result.sourceLibrary , result.closestTitle ?  result.closestTitle : result.secondClosestTitle);
        }
        if (result.sourceLibrary === this.infoLibraries.FAQ) {
            this.goToInfoPage(result.sourceLibrary , result.closestTitle ?  result.closestTitle : result.secondClosestTitle);
        }
        else if (result.sourceLibrary === "What's New") {
            this.pageModule = this.dic.CONSTANTS.supportPageModules.timeScale;
            setTimeout(() => {
                this.scrollToAnchor(result.closestTitle);
            });
        }

		// highlight search text in info page content text.
		// this action might take some time to complete, place it in the end
		setTimeout(() => {
			this.highlightSearchResults = true;
			this.highlightSearchText = this.searchQuery;
		}, 20);
	}

	// CC: taken from user-management.component.ts -> updateGeneralSettings
	updateWhatsNewNotification = () => {
		const actionInfo = {
			action: this.dic.CONSTANTS.planOutboundAction.generalSettings,
			key: 'send_whats_new_alert_notification',
			enabled: this.userInfo.plan.send_whats_new_alert_notification
		};
		this.rs.doActionOnOutboundPlan(actionInfo).then(() => {
		}, (err) => {
			if (err && err.data && err.data.message && !err.data.display_bar) {
				this.ns.showErrorMessage(err.data.message);
			}
		});
	};

	updateWhatsNewCategoryFilter = (module) => {
		module.enabled = !module.enabled;
		this.ns.showInfoMessage(util.format(DICTIONARY.MESSAGES.itemUpdated, 'Filter'));
		let enabledModules = Object.keys(this.trustifiModules).filter(moduleName => this.trustifiModules[moduleName].enabled);
		if (!enabledModules.length) {
			enabledModules = Object.keys(this.trustifiModules);
		}

		this.whatsNewData.forEach((newFeaturesBundle:any) => {
			let showBundle = false;
			newFeaturesBundle.features.forEach((feature:any) => {
				feature.show = !!_.intersection(enabledModules, feature.modules).length;
				showBundle = showBundle || feature.show;
			});
			newFeaturesBundle.show = showBundle;
		});
	}
}
